/**
 * Renders the backend-provided `filters` map. These are read-only for now
 * (no run/re-query endpoint exists yet), so we display them as labelled chips.
 * @param {{ filters?: Record<string, string> }} props
 */
export function FilterToolbar({ filters }) {
  const entries = Object.entries(filters || {});
  return (
    <div className="border-b border-eorig-border bg-eorig-surface px-5 py-4 sm:px-6">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-eorig-muted">
        Filters
      </p>
      {entries.length ? (
        <div className="mt-3 flex flex-wrap gap-2">
          {entries.map(([key, value]) => (
            <span
              key={key}
              className="inline-flex items-center gap-1.5 rounded-full border border-eorig-border bg-white px-3 py-1.5 text-xs text-eorig-ink"
            >
              <span className="font-medium text-eorig-muted">{key.replace(/_/g, ' ')}:</span>
              <span className="font-semibold">{value}</span>
            </span>
          ))}
        </div>
      ) : (
        <p className="mt-2 text-xs text-eorig-muted">No filters applied.</p>
      )}
    </div>
  );
}
